export const shouldSubmitChatOnKeyDown = (
  event,
  { isComposing, isButtonDisabled, isAIResponding }
) => {
  if (event.key !== "Enter") return false;

  const nativeEvent = event.nativeEvent || event;
  const isImeComposing =
    isComposing ||
    nativeEvent.isComposing ||
    event.keyCode === 229 ||
    nativeEvent.keyCode === 229;

  return !isImeComposing && !isButtonDisabled && !isAIResponding;
};
